@if (loaded) {
  <div class="card border-0 shadow mb-3 fade-in-zoom">
    <div class="card-header fw-bold bg-tertiary p-3 border-0 d-flex justify-content-between align-items-center">
      <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-crosshair me-2 text-primary"></i>Goals</h2>
    </div>
    <div class="card-body">
      @if (isMissingGoal()) {
        <div class="alert alert-danger py-2 small">
          <i class="bi bi-exclamation-triangle me-1"></i>
          This offer is open to affiliates but has no goal: its conversions are paid but stay private and never reach the invoice.
        </div>
      }
      <div class="table-responsive">
        <table class="table table-hover table-striped align-middle">
          <thead>
            <tr>
              <th>Status</th>
              <th>Name</th>
              <th>Private</th>
              <th>Multiple</th>
              <th>Min Age</th>
              <th>Payout Amount</th>
              <th>Payout Percent</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            @for (goalInfo of goalInfoList; track goalInfo) {
              <tr>
                <td>
                  <app-input-switch (change)="onChangeStatus(goalInfo.goal, $event)"
                  [ngModel]="!!goalInfo.offerGoal" [disabled]="!canUpdate()"></app-input-switch>
                </td>
                <td>{{ goalInfo.goal.name }}</td>
                <td>
                  @if (goalInfo.offerGoal && goalInfo.offerGoal?.private) {
                    <span class="badge bg-success">Yes</span>
                  }
                  @if (goalInfo.offerGoal && !goalInfo.offerGoal?.private) {
                    <span class="badge bg-danger">No</span>
                  }
                </td>
                <td>
                  @if (goalInfo.offerGoal && goalInfo.offerGoal?.multiple) {
                    <span class="badge bg-success">Yes</span>
                  }
                  @if (goalInfo.offerGoal && !goalInfo.offerGoal?.multiple) {
                    <span class="badge bg-danger">No</span>
                  }
                </td>
                <td>{{ goalInfo.offerGoal?.minAge }}</td>
                <td>
                  @if (goalInfo.offerGoal?.payoutAmount) {
                    <span
                    >{{ $safeNavigationMigration(goalInfo.offerGoal?.payoutAmount) | currency:2:$safeNavigationMigration(offer?.currency?.isoCode) }}</span>
                  }
                </td>
                <td>
                  @if (goalInfo.offerGoal?.payoutPercent) {
                    <span>{{ $safeNavigationMigration(goalInfo.offerGoal?.payoutPercent) | percent }}</span>
                  }
                </td>
                <td class="text-center">
                  <ng-container *isGranted="['ROLE_API_OFFER_WRITE']">
                    @if (!!goalInfo.offerGoal) {
                      <button class="btn btn-outline-primary btn-sm me-1"
                        (click)="edit(goalInfo.offerGoal)"><i class="bi bi-pencil me-1"></i>Edit
                      </button>
                    }
                  </ng-container>
                  @if (!!goalInfo.offerGoal) {
                    <button [disabled]="!goalInfo.offerGoal?.types.length"
                      class="btn btn-outline-primary btn-sm"
                      (click)="toggleDetails(goalInfo)"><i class="bi bi-info-square me-1"></i>Détails
                    </button>
                  }
                </td>
              </tr>
              @if (goalInfo.offerGoal?.types.length && goalInfo.detailExpanded) {
                <tr>
                  <td></td>
                  <td colspan="6">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Type</th>
                          <th>Min Age</th>
                          <th>Payout Amount</th>
                          <th>Payout Percent</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (offerGoalType of goalInfo.offerGoal?.types; track offerGoalType) {
                          <tr>
                            <td>{{ offerGoalType.goalType.name }}</td>
                            <td>{{ offerGoalType?.minAge }}</td>
                            <td>@if (offerGoalType?.payoutAmount) {
                              <span
                              >{{ $safeNavigationMigration(offerGoalType?.payoutAmount) | currency:2:$safeNavigationMigration(offer?.currency?.isoCode) }}</span>
                            }
                          </td>
                          <td>@if (offerGoalType?.payoutPercent) {
                            <span>{{ $safeNavigationMigration(offerGoalType?.payoutPercent) | percent }}</span>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</div>
</div>
}
